import {
  Gauge,
  LineChart as LineChartIcon,
  Users,
  Factory,
  Globe2,
  GlassWater,
  Sparkles,
  Trophy,
  CalendarRange,
  Scissors,
  Truck,
} from "lucide-react";
import { cn } from "@/lib/utils";

const NAV_ITEMS = [
  { id: "insighturi", label: "Insighturi", icon: Sparkles },
  { id: "cost-productie", label: "Cost producție", icon: Gauge },
  { id: "media-mobila", label: "Media mobilă", icon: LineChartIcon },
  { id: "profitabilitate", label: "Profitabilitate", icon: Users },
  { id: "masini", label: "Mașini & operatori", icon: Factory },
  { id: "export", label: "Export vs. intern", icon: Globe2 },
  { id: "top-clienti", label: "Top clienți", icon: Trophy },
  { id: "mix-sezonalitate", label: "Mix & sezonalitate", icon: CalendarRange },
  { id: "pierderi", label: "Pierderi / waste", icon: Scissors },
  { id: "livrari", label: "Livrări", icon: Truck },
];

interface SidebarProps {
  activeId: string;
  onNavigate: (id: string) => void;
}

export function Sidebar({ activeId, onNavigate }: SidebarProps) {
  return (
    <aside className="hidden lg:flex lg:w-64 lg:flex-col lg:fixed lg:inset-y-0 border-r border-slate-200 bg-white print:hidden">
      <div className="flex items-center gap-2 px-6 h-16 border-b border-slate-200">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-600 text-white">
          <GlassWater className="h-4.5 w-4.5" />
        </div>
        <div>
          <p className="text-sm font-semibold text-slate-900 leading-tight">Glass Expert</p>
          <p className="text-xs text-slate-500 leading-tight">BI Dashboard</p>
        </div>
      </div>
      <nav className="flex-1 overflow-y-auto px-3 py-4 space-y-1">
        {NAV_ITEMS.map((item) => {
          const Icon = item.icon;
          const active = activeId === item.id;
          return (
            <button
              key={item.id}
              onClick={() => onNavigate(item.id)}
              className={cn(
                "flex w-full items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors",
                active
                  ? "bg-brand-50 text-brand-700"
                  : "text-slate-600 hover:bg-slate-100 hover:text-slate-900",
              )}
            >
              <Icon className={cn("h-4.5 w-4.5", active ? "text-brand-600" : "text-slate-400")} />
              {item.label}
            </button>
          );
        })}
      </nav>
      <div className="px-4 py-4 border-t border-slate-200 text-xs text-slate-400">
        P5 · BI Raportare
        <br />
        Owner date: @dragos · UI: @admin-architect
      </div>
    </aside>
  );
}

export const SIDEBAR_NAV_IDS = NAV_ITEMS.map((i) => i.id);
